import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Stock Market Foundations & Financial Basics",
    description:
      "About  stock market & how it works, Exchanges: NSE BSE SEBI overview, Types of financial instruments: Equity Bonds ETFs Commodities, Market participants: traders investors FIIs DIIs, Understanding risk reward & market psychology",
  },
  {
    title: "HTML, CSS & UI Fundamental Analysis & Company Evaluation",
    description:
      "Exchanges: NSE BSE SEBI overview, Types of financial instruments: Equity Bonds ETFs Commodities, Market participants: traders investors FIIs DIIs, Understanding risk reward & market psychology",
  },
  {
    title: "Technical Analysis & Chart Reading Mastery",
    description:
      "Candlestick patterns & chart types, Support resistance & trendlines, Chart indicators: RSI MACD Moving Averages, Price action trading basics, Identifying entry & exit points",
  },
  {
    title: "Trading Psychology & Market Behavior",
    description:
      "Managing fear greed & overtrading, Creating a disciplined trading mindset, Understanding market sentiment, Avoiding common investor mistakes, Emotional intelligence for traders",
  },
  {
    title: "Derivatives: Futures, Options & Hedging Strategies",
    description:
      "Basics of futures & options trading, Calls puts premium strike price time decay, Option Greeks (Delta Theta Vega) simplified, Hedging risk with derivatives, Building basic option strategies",
  },
  {
    title: "Intraday, Swing & Long-Term Trading Strategies",
    description:
      "Scalping vs intraday vs positional trading, Breakout & breakdown strategies, Swing trading with indicators, Portfolio building for long-term gains, Backtesting strategies for confidence",
  },
  {
    title: "Risk Management & Portfolio Optimization",
    description:
      "Position sizing & stop-loss rules, Diversification strategies, Building low-risk high-performing portfolios, Asset allocation across equity debt & gold, Minimizing losses during market volatility",
  },
  {
    title: "Tools, Platforms & Market Analytics",
    description:
      "Demat & trading accounts setup, Using platforms: Zerodha Upstox Groww, Stock screeners & scanners, Reading market depth & order book, Using Algo & automated trading tools (basics)",
  },
  {
    title: "Mutual Funds, SIPs, ETFs & Wealth Building",
    description:
      "Understanding different mutual funds, SIP strategy for long-term wealth, ETF investing & index funds, Goal-based financial planning, Tax-saving investments under 80C",
  },
  {
    title: "Capstone Trading Project & Career Launchpad",
    description:
      "Create your own trading plan, Analyze a company & build a complete report, Paper trading practice, Portfolio presentation & performance analysis, Career prep for roles: Trader Analyst Wealth Manager",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
